import { useState } from 'react';
import { Box } from '@mui/material';

import { airlineLogoSrc } from './airlineLogos';

interface Props {
  /** Código IATA de la aerolínea. */
  code: string;
  size?: number;
}

/**
 * El logo de la aerolínea, al lado de su código. Sin logo en la lista, o si la
 * imagen no carga, no se dibuja nada: el código que la acompaña queda como texto.
 */
export function AirlineLogo({ code, size = 24 }: Props) {
  const src = airlineLogoSrc(code);
  const [failed, setFailed] = useState<string | null>(null);
  if (!src || failed === src) return null;
  return (
    <Box
      component="img"
      src={src}
      alt=""
      aria-hidden
      onError={() => setFailed(src)}
      sx={{
        width: size,
        height: size,
        objectFit: 'contain',
        flexShrink: 0,
        borderRadius: 1,
        bgcolor: 'common.white',
        p: '2px',
      }}
    />
  );
}
